import * as React from 'react'

import { styled } from '../../../common/ui'
import { theme } from '../theme'

export class InputFile extends React.Component<
  {
    id: string
    label: string
    onChange?: (currentTarget: HTMLInputElement) => void
    onBlur?: () => void
  },
  {}
> {
  render() {
    const { onChange, onBlur, label } = this.props
    return (
      <Styled>
        <input
          type="file"
          onChange={e => {
            onBlur && onBlur()
            onChange && onChange(e.currentTarget)
          }}
          onBlur={e => {
            onBlur && onBlur()
          }}
        />
        <label>{label}</label>
      </Styled>
    )
  }
}

const Styled = styled.div`
  display: inline-block;
  > input {
    border: 3px solid black;
    background: #dadada;
    font-size: 18px;
    font-weight: normal;
    padding: 5px;
    width: 100%;
    max-width: 320px;
    &:hover {
      border: 3px solid ${theme.colors.blue};
    }
    &:active,
    &:focus {
      border: 3px solid ${theme.colors.blue};
      background: #fff;
      outline: none;
    }

    &[data-has-error='1'] {
      border: 3px solid ${theme.colors.red};
    }
  }
  > input + label {
    display: none;
  }
`
